import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from './helpers/auth.guard';
import { AdminLayoutComponent } from './layouts/admin-layout/admin-layout.component';
import { NotAuthComponent } from 'projects/shared/src/pages/not-auth/not-auth.component';
import { ErrorComponent } from 'projects/shared/src/pages/error/error.component';
import { SystemModule } from './features/central-hub/models/enums/SystemModule';
import { ConsumerAmbassadorsProfileComponent } from './shared/components/consumer-ambassadors-profile/consumer-ambassadors-profile.component';
import { BlankLayoutComponent } from './layouts/blank-layout/blank-layout.component';
import { BasicLayoutComponent } from './layouts/basic-layout/basic-layout.component';
import { TabsLayoutComponent } from './layouts/tabs-layout/tabs-layout.component';

const routes: Routes = [
  {
    path: '',
    component: BlankLayoutComponent,
    children: [
      { path: '', loadChildren: () => import('./features/auth/auth.module').then(m => m.AuthModule) },
      { path: 'certificate-shared', loadChildren: () => import('projects/shared/src/modules/certificate-shared-view/certificate-shared-view.module').then(m => m.CertificateSharedViewModule) },
    ]
  },
  {
    path: 'admin',
    component: AdminLayoutComponent,
    canActivate: [AuthGuard],
    children: [
      // { path: '', redirectTo: (localStorage.getItem('baseRoute') || ''), pathMatch: 'full' },
      {
        path: `${SystemModule.UserManagement}`,
        children: [
          { path: `roles`, loadChildren: () => import('./features/user-management/roles/roles.module').then(m => m.RolesModule) },
          { path: `internal-users`, loadChildren: () => import('./features/user-management/internal-users/internal-users.module').then(m => m.InternalUsersModule) },
          { path: `external-users`, loadChildren: () => import('./features/user-management/external-users/external-users.module').then(m => m.ExternalUsersModule) },
          { path: `consumers`, loadChildren: () => import('./features/user-management/consumers-users/consumers-users.module').then(m => m.ConsumersUsersModule) },
          { path: `ambassador-users`, loadChildren: () => import('./features/user-management/consumer-ambassadors/consumer-ambassadors.module').then(m => m.ConsumerAmbassadorsModule) }
        ]
      },
      {
        path: `${SystemModule.PlatformLevelGeneralSettings}`,
        children: [
          { path: `commercial-sectors`, loadChildren: () => import('./features/commercial-sectors/commercial-sectors.module').then(m => m.CommercialSectorsModule) },
          { path: `economic-operators`, loadChildren: () => import('./features/economic-operators/economic-operators.module').then(m => m.EconomicOperatorsModule) },
          { path: `products-categories`, loadChildren: () => import('./features/products-categories/products-categories.module').then(m => m.ProductsCategoriesModule) },
          { path: `product-list`, loadChildren: () => import('./features/product-list/product-list.module').then(m => m.ProductListModule) },
          { path: `product-brands`, loadChildren: () => import('./features/product-brands/product-brands.module').then(m => m.ProductBrandsModule) },
          { path: `escalation-entities`, loadChildren: () => import('./features/entities/entities.module').then(m => m.EntitiesModule) },
        ]
      },
      {
        path: `${SystemModule.PriceIndexandComparison}`,
        children: [
          { path: `publish-prices`, loadChildren: () => import('./features/publish-prices/publish-prices.module').then(m => m.PublishPricesModule) },
          { path: `settings/product-baskets`, loadChildren: () => import('./features/product-baskets/product-baskets.module').then(m => m.ProductBasketsModule) },
          { path: `monitoring-plans`, loadChildren: () => import('./features/monitoring-plans/monitoring-plans.module').then(m => m.MonitoringPlansModule) },
          { path: `product-prices`, loadChildren: () => import('./features/products-prices/products-prices.module').then(m => m.ProductsPricesModule) },
          { path: `consumers-invoices`, loadChildren: () => import('./features/consumers-invoices/consumers-invoices.module').then(m => m.ConsumersInvoicesModule) },
        ]
      },
      {
        path: `${SystemModule.StoreEvaluationandEconomicOperatorComplianceIndex}`,
        children: [
          { path: `evaluation-requests`, loadChildren: () => import('./features/evaluation-requests/evaluation-requests.module').then(m => m.EvaluationRequestsModule) },
          { path: `settings/inspection-rules`, loadChildren: () => import('./features/inspection-rules/inspection-rules.module').then(m => m.InspectionRulesModule) },
          { path: `settings/evaluation-surveys`, loadChildren: () => import('./features/evaluation-surveys/evaluation-surveys.module').then(m => m.EvaluationSurveysModule) },
          { path: `settings/compliance-categories`, loadChildren: () => import('./features/compliance-categories/compliance-categories.module').then(m => m.ComplianceCategoriesModule) }
        ]
      },
      {
        path: `${SystemModule.ConsumerAmbassador}`,
        children: [
          { path: `cpadashboard`, loadChildren: () => import('./features/connect/cpa-dashboard/cpa-dashboard.module').then(m => m.cpaDashboardModule) },
          { path: `tasks`, loadChildren: () => import('./features/connect/tasks/tasks.module').then(m => m.TasksModule) },
          { path: `managtracks`, loadChildren: () => import('./features/connect/manageentity/manageentity.module').then(m => m.ManageentityModule) },
          { path: `managegroups`, loadChildren: () => import('./features/connect/managegroups/managegroups.module').then(m => m.ManagegroupsModule) },
          { path: `meetings`, loadChildren: () => import('./features/connect/meetings/meetings.module').then(m => m.MeetingsModule) },
          { path: `badgesmanagement`, loadChildren: () => import('./features/connect/badges-management/badges-management.module').then(m => m.BadgesManagementModule) },
          { path: `ambassadorspromotion`, loadChildren: () => import('./features/connect/ambassadors-promotion/ambassador-promotion..module').then(m => m.AmbassadorsPromotionModule) },
          { path: `contribution`, loadChildren: () => import('./features/connect/contribution/contribution.module').then(m => m.ContributionModule) },
          { path: `reports`, loadChildren: () => import('./features/connect/reports/reports.module').then(m => m.ReportsModule) },
          { path: `mybadges`, loadChildren: () => import('./features/connect/user-badges/user-badges.module').then(m => m.UserBadgesModule) },
        ]
      },
      {
        path: `${SystemModule.DiscountsandCompetitionsComplianceVerification}`,
        children: [
          { path: `verification-requests`, loadChildren: () => import('./features/verification-requests/verification-requests.module').then(m => m.VerificationRequestsModule) },
          { path: `settings/check-types`, loadChildren: () => import('./features/check-types/check-types.module').then(m => m.CheckTypesModule) },
          { path: `settings/check-forms`, loadChildren: () => import('./features/check-forms/check-forms.module').then(m => m.CheckFormsModule) },
        ]
      },
      {
        path: `${SystemModule.TechnicalProductComparisonandLaboratoryTesting}`,
        children: [
          { path: `product-evaluation-requests`, loadChildren: () => import('./features/product-evaluation-requests/product-evaluation-requests.module').then(m => m.ProductEvaluationRequestsModule) },
          { path: `settings/criteria-and-weight`, loadChildren: () => import('./features/technical-criteria/technical-criteria.module').then(m => m.TechnicalCriteriaModule) },
          { path: `settings/evaluation-forms`, loadChildren: () => import('./features/product-evaluation-forms/product-evaluation-forms.module').then(m => m.ProductEvaluationFormsModule) },
          { path: `technical-evaluation-comparison`, loadChildren: () => import('./features/technical-evaluation-comparison/technical-evaluation-comparison.module').then(m => m.TechnicalEvaluationComparisonModule) },
        ]
      },
      {
        path: `${SystemModule.MyTasks}`,
        children: [
          { path: `assessment-tasks/:hubCode`, loadChildren: () => import('./features/ambassador-evaluation-tasks/ambassador-evaluation-tasks.module').then(m => m.AmbassadorEvaluationTasksModule) },
          { path: `monitoring-tasks/:hubCode`, loadChildren: () => import('./features/ambassador-monitoring-tasks/ambassador-monitoring-tasks.module').then(m => m.AmbassadorMonitoringTasksModule) },
          { path: `verification-tasks/:hubCode`, loadChildren: () => import('./features/ambassador-verification-tasks/ambassador-verification-tasks.module').then(m => m.AmbassadorVerificationTasksModule) },
          { path: `product-evaluation-task/:hubCode`, loadChildren: () => import('./features/ambassador-product-evaluation-task/ambassador-product-evaluation-task.module').then(m => m.AmbassadorProductEvaluationTaskModule) },
          { path: `fraud-tasks/:hubCode`, loadChildren: () => import('./features/ambassador-fraud-monitoring-tasks/ambassador-fraud-monitoring-tasks.module').then(m => m.AmbassadorFraudMonitoringTasksModule) },
          { path: 'survey-tasks/:hubCode', loadChildren: () => import('./features/ambassador-surveys-tasks/ambassador-surveys-tasks.module').then(m => m.AmbassadorSurveysTasksModule) },
          { path: 'consultation-tasks/:hubCode', loadChildren: () => import('./features/ambassador-consultation-tasks/ambassador-consultation-tasks.module').then(m => m.AmbassadorConsultationTasksModule) },
        ]
      },
      {
        path: `${SystemModule.Complaints}`,
        children: [
          { path: 'complaints-settings', loadChildren: () => import('./features/complaints-settings/complaints-settings.module').then(m => m.ComplaintsSettingsModule) },
          { path: 'complaints', loadChildren: () => import('./features/complaints/complaints.module').then(m => m.ComplaintsModule) }
        ]
      },
      {
        path: `${SystemModule.AdsandFraudMonitoring}`,
        children: [
          { path: `fraud-monitoring-requests`, loadChildren: () => import('./features/fraud-monitoring-requests/fraud-monitoring-requests.module').then(m => m.FraudMonitoringRequestsModule) },
          { path: 'settings/fraud-types', loadChildren: () => import('./features/fraud-types/fraud-types.module').then(m => m.FraudTypesModule) },
          { path: 'settings/check-forms', loadChildren: () => import('./features/fraud-forms/fraud-forms.module').then(m => m.FraudFormsModule) },
        ]
      },
      { path: `${SystemModule.OperatorComplaints}`, loadChildren: () => import('./features/complaints/complaints.module').then(m => m.ComplaintsModule) },
      {
        path: `${SystemModule.ConsumerVoiceServices}`,
        component: TabsLayoutComponent,
        children: [
          { path: `compliance-reports`, loadChildren: () => import('./features/compliance-reports/compliance-reports.module').then(m => m.ComplianceReportsModule) },
          { path: `special-offers`, loadChildren: () => import('./features/special-offers/special-offers.module').then(m => m.SpecialOffersModule) },
          { path: 'certificates', loadChildren: () => import('./features/operator-certificates/operator-certificates.module').then(m => m.OperatorCertificatesModule) },
          { path: `offers`, loadChildren: () => import('./features/offers/offers.module').then(m => m.OffersModule) },
        ]
      },
      {
        path: `${SystemModule.DocumentsandInvoicesManagement}`,
        children: [
          { path: `documents-and-invoices`, loadChildren: () => import('./features/documents-invoices/documents-invoices.module').then(m => m.DocumentsInvoicesModule) },
          { path: `settings/document-categories`, loadChildren: () => import('./features/documents-categories/documents-categories.module').then(m => m.DocumentsCategoriesModule) },

        ]
      },
      {
        path: `${SystemModule.SurveysandOpinionPolls}`,
        children: [
          { path: `survey-requests`, loadChildren: () => import('./features/surveys-requests/surveys-requests.module').then(m => m.SurveysRequestsModule) },
          { path: `settings/survey-templates`, loadChildren: () => import('./features/survey-opinion-poll/survey-opinion-poll.module').then(m => m.SurveyOpinionPollModule) },
          { path: `published-survey`, loadChildren: () => import('./features/published-surveys/published-surveys.module').then(m => m.PublishedSurveysModule) },

        ]
      },
      {
        path: `${SystemModule.RightsandDuties}`,
        children: [
          { path: 'dashboard', loadChildren: () => import('./features/dashboard/dashboard.module').then(m => m.DashboardModule) },
          { path: 'categories', loadChildren: () => import('./features/categories/categories.module').then(m => m.CategoriesModule) },
        ]
      },
      {
        path: `${SystemModule.ConsumerFriendsPartners}`,
        children: [
          { path: 'certificate-requests', loadChildren: () => import('./features/certificate-requests/certificate-requests.module').then(m => m.CertificateRequestsModule) },
          { path: `special-offers`, loadChildren: () => import('./features/offers/offers.module').then(m => m.OffersModule) },

        ]
      },
      {
        path: `${SystemModule.LegalConsultationsandAISystem}`,
        children: [
          { path: 'settings/consultation-types', loadChildren: () => import('./features/consultations-types/consultations-types.module').then(m => m.ConsultationsTypesModule) },
          { path: 'consultation-requests', loadChildren: () => import('./features/consultation-requests/consultation-requests.module').then(m => m.ConsultationRequestsModule) },
          { path: 'consultation-sessions', loadChildren: () => import('./features/consultation-sessions/consultation-sessions.module').then(m => m.ConsultationSessionsModule) },
        ]
      },
      {
        path: `${SystemModule.AdminAcademy}`,
        children: [
          { path: 'settings/subSpeciality', loadChildren: () => import('./features/subspecialty-configuration/subspecialty-configuration.module').then(m => m.SubspecialtyConfigurationModule) },
          { path: 'courses-management/course-categories', loadChildren: () => import('./features/course-categories/course-categories.module').then(m => m.CourseCategoriesModule) },
          { path: 'courses-management/courses', loadChildren: () => import('./features/course-management/course-management.module').then(m => m.CourseManagementModule) },
          { path: 'trainers', loadChildren: () => import('./features/pathologists/pathologists.module').then(m => m.PathologistsModule) },
          { path: 'certificate-management', loadChildren: () => import('./features/certificate-management/certificate-management.module').then(m => m.CertificateManagementModule) },
        ]
      },
      {
        path: `${SystemModule.AdvertisementsAndBanners}`,
        children: [
          { path: 'advertisement-management', loadChildren: () => import('./features/ads-and-banners/ads-and-banners.module').then(m => m.AdsAndBannersModule) },
        ]
      }, {
        path: `${SystemModule.UserAcademy}`,
        // component: TabsLayoutComponent,
        children: [
          { path: 'courses', loadChildren: () => import('projects/shared/src/modules/courses/courses.module').then(m => m.CoursesModule) },
          { path: 'all-courses', loadChildren: () => import('projects/shared/src/modules/public-courses/public-courses.module').then(m => m.PublicCoursesModule) },
          { path: 'certificates', loadChildren: () => import('projects/shared/src/modules/certificates-trainee/certificates-trainee.module').then(m => m.CertificatesTraineeModule) },
        ]
      },
      {
        path: `${SystemModule.ConsumerSubscriptionsManagement}`,
        children: [
          { path: 'settings/subscription-plans', loadChildren: () => import('./features/subscription-plans/subscription-plans.module').then(m => m.SubscriptionPlansModule) },
          { path: 'consumer-subscriptions', loadChildren: () => import('./features/consumer-subscriptions/consumer-subscriptions.module').then(m => m.ConsumerSubscriptionsModule) },
        ]
      },
      {
        path: `:hubCode`,
        children: [
          { path: `product-evaluation-tasks`, loadChildren: () => import('./features/product-evaluation-tasks/product-evaluation-tasks.module').then(m => m.ProductEvaluationTasksModule) },
          { path: `verification-tasks`, loadChildren: () => import('./features/verification-tasks/verification-tasks.module').then(m => m.VerificationTasksModule) },
          { path: `evaluation-tasks`, loadChildren: () => import('./features/evaluation-tasks/evaluation-tasks.module').then(m => m.EvaluationTasksModule) },
          { path: `fraud-monitoring-tasks`, loadChildren: () => import('./features/fraud-monitoring-tasks/fraud-monitoring-tasks.module').then(m => m.FraudMonitoringTasksModule) },
          { path: `monitor-tasks`, loadChildren: () => import('./features/price-monitoring-tasks/price-monitoring-tasks.module').then(m => m.PriceMonitoringTasksModule) },
          { path: `survey-tasks`, loadChildren: () => import('./features/survey-tasks/survey-tasks.module').then(m => m.SurveyTasksModule) },
          { path: `settings/tracks-and-task-reviewers`, loadChildren: () => import('./features/tracks-and-task-reviewers/tracks-and-task-reviewers.module').then(m => m.TracksAndTaskReviewersModule) },
          { path: 'rights', loadChildren: () => import('./features/rights/rights.module').then(m => m.RightsModule) },
          { path: 'regulations', loadChildren: () => import('./features/regulations/regulations.module').then(m => m.RegulationsModule) },
        ]
      },
      { path: '**', component: ErrorComponent }
    ]
  },
  {
    path: 'main',
    component: BasicLayoutComponent,
    children: [
      { path: '', redirectTo: (localStorage.getItem('baseRoute') || 'central-hub'), pathMatch: 'full' },
      { path: 'central-hub', loadChildren: () => import('./features/central-hub/central-hub.module').then(m => m.CentralHubModule) },
      { path: 'user-profile', loadChildren: () => import('./features/user-profile/user-profile.module').then(m => m.UserProfileModule) },
      { path: `entities`, loadChildren: () => import('./features/entities/entities.module').then(m => m.EntitiesModule) },
      { path: 'ambassador-profile', component: ConsumerAmbassadorsProfileComponent }
    ]
  },
  { path: 'notAuthorized', component: NotAuthComponent },
  { path: 'notFound', component: ErrorComponent },
  { path: '**', component: ErrorComponent },
  // otherwise redirect to home
  { path: '**', redirectTo: '' },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {
    scrollPositionRestoration: 'enabled',
    anchorScrolling: 'enabled'
  })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
